import { c as _c } from "react/compiler-runtime";
import { InfoIcon, Text } from "@flat-ui";
/** Renders a message to be shown below a text field */
export function FaroTextFieldMessage(t0) {
  const $ = _c(10);
  const {
    shouldHide: t1,
    message
  } = t0;
  const shouldHide = t1 === undefined ? false : t1;
  if (!message || shouldHide) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <></>;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  const t2 = message?.type === "error" ? "error.main" : "inherit";
  const t3 = message ? "visible" : "hidden";
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = {
      color: t2,
      display: "flex",
      alignItems: "center",
      visibility: t3
    };
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== message.type) {
    t5 = message?.type === "info" && <InfoIcon sx={{
      marginRight: "5px",
      height: "12px",
      width: "12px"
    }} />;
    $[4] = message.type;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== message.helperText || $[7] !== t4 || $[8] !== t5) {
    t6 = <Text variant="helpText" sx={t4}>{t5}{message.helperText}</Text>;
    $[6] = message.helperText;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}